import request from '@/router/axios'
import env from '@/config/env'


/**
 * 获取老系统线路枚举
 * @param data
 *
 */
 export const getOldLineEnum = (data) => {
    return request({
        url: env.ferryUrl + '/lineConfig/lineList',
        // url: 'http://192.168.1.103:38000/lineConfig/lineList',
        method: 'GET',
        data: data
    })
}

/**
 * 获取新系统出发地、目的地枚举
 * @param data
 *
 */
 export const getLineConfigEnums = (data) => {
    return request({
        url: env.ferryUrl + '/commonAdmin/getAreaManageList',
        // url: 'http://192.168.1.103:38000/commonAdmin/getAreaManageList',
        method: 'GET',
        data: data
    })
}

/**
 * 获取线路跳转配置分页数据
 * @param data
 *
 */
 export const getLineConfigPage = (data) => {
    return request({
        url: env.ferryUrl + '/lineConfig/page',
        // url: 'http://192.168.1.103:38000/lineConfig/page',
        method: 'POST',
        data: data
    })
}


/**
 * 新增线路跳转配置
 * @param data
 */
export const addLineConfig = (data) => {
    return request({
        url: env.ferryUrl + '/lineConfig/save',
        // url: 'http://192.168.1.103:38000/lineConfig/save',
        method: 'POST',
        data: data
    })
}

/**
 * 删除线路跳转配置
 * @param data
 */
 export const removeLineConfig = (id) => {
    return request({
        url: env.ferryUrl + `/lineConfig/delete/${id}`,
        // url: 'http://192.168.1.103:38000/lineConfig/delete/{sysPropertiesInfoId}',
        method: 'DELETE'
    })
}